<div class="purpose-container">
    <div *ngFor="let item of listPurposes; index as i" class="purpose-box" [ngClass]="{'last-child': i === listPurposes.length -1 }">
        <div class="purpose-checkbox-row">
            <div>
                <bci-wk-checkbox class="checkbox-wrap" (change)="onPurposeToggle(item,$event)" ></bci-wk-checkbox>
            </div>
            <div class="purpose-main" *ngIf="item.id">
                <div class="purpose-desc" [innerHTML]="item.description"></div>
            </div>
        </div>
    </div>
</div>
